import React from 'react';
import PropTypes from 'prop-types';
import GatsbyLink from 'gatsby-link';

import { css, withStyles, withStylesPropTypes } from 'airbnb-dls-web/build/themes/withStyles';
import Spacing from 'airbnb-dls-web/build/exp/Spacing';
import Text from 'airbnb-dls-web/build/exp/Text';
import Column from 'airbnb-dls-web/build/exp/Column';

import StarsAndForks from '../components/StarsAndForks';
import { getProjectPageRoute } from '../utils/routing';

const brand = [
  '#cce4e7',
  '#ccf6f3',
  '#ffeee9',
  '#ebeceb',
  '#e8f9e3',
  '#fff0cc',
  '#f0ede2',
  '#e5ccdc',
  '#dddede',
];

const propTypes = {
  ...withStylesPropTypes,
  logo: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  stars: PropTypes.string,
  forks: PropTypes.string,
  hideDescription: PropTypes.bool,
};

const defaultProps = {
  hideDescription: false,
  stars: null,
  forks: null,
};

class ProjectCard extends React.Component {
  render() {
    const { logo, id, title, description, stars, forks, hideDescription } = this.props;
    return (
      <div style={{ height: 120 }}>
        <GatsbyLink
          to={getProjectPageRoute(id)}
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'block',
          }}
        >
          <Spacing top={2} bottom={2}>
            <Column md={3} sm={3}>
              <img
                alt="logo"
                src={logo}
                style={{
                  transform: 'translate(15%, 0)',
                  marginTop: '',
                  maxHeight: 60,
                  maxWidth: '100%',
                }}
              />
            </Column>
            <Column md={9} sm={9}>
              <div>
                <Text bold>
                  {title}{' '}
                  {!hideDescription && (
                    <Text muted light inline>
                      {description}
                    </Text>
                  )}
                </Text>
                {stars &&
                  forks && (
                    <div style={{ display: 'inline-block', marginRight: 8 }}>
                      <div
                        style={{
                          lineHeight: 1,
                          padding: '4px 0',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          background: 'white',
                        }}
                      >
                        <StarsAndForks sameLine stars={stars} forks={forks} />
                      </div>
                    </div>
                  )}
              </div>
            </Column>
          </Spacing>
        </GatsbyLink>
      </div>
    );
  }
}

ProjectCard.propTypes = propTypes;
ProjectCard.defaultProps = defaultProps;

export default withStyles(() => ({
  center: {
    textAlign: 'center',
  },
}))(ProjectCard);



// WEBPACK FOOTER //
// ./src/components/ProjectCard.jsx